import request from '@/config/axios'

export const GetLang = (params) => {
  return request.get({
    url: '/api/v2/i18n-data',
    baseUrl:'api-desk',
    params
  })
}

export const RegisterLang = (data) => {
    return request.post({
        url: '/api/v2/i18n-data/builtin',
        baseUrl:'api-desk',
        data,
    })
}

export const GetDeskApps = (params) => {
  return request.get({
    baseUrl:'deskapp',
    url: 'app',
    params: params,
  })
}
